///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { createAction, props } from '@ngrx/store';

export const deleteProject = createAction('[ProjectModalManagement] Delete Project');

export const createProject = createAction('[ProjectModalManagement] Create Project');

export const moveProject = createAction('[ProjectModalManagement] Move Project', props<{ targetCustomerId: number }>());
